import React from 'react';
import { Link } from 'react-router-dom';
import './EnterpriseLayout.css';
import { ArrowBackRounded, CloseRounded, WarningAmberRounded } from '@mui/icons-material';

export function BrandMark({ size = 32 }) {
  return (
    <svg
      className="vt-brandLogo"
      width={size}
      height={size}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g transform="translate(100,100)" stroke="currentColor" strokeWidth="5" strokeLinecap="round">
        <g>
          <circle cx="0" cy="0" r="82" fill="none" stroke="none" />
          {[...Array(20)].map((_, i) => (
            <line
              key={`outer-${i}`}
              x1="0"
              y1="-82"
              x2="0"
              y2="-70"
              transform={`rotate(${i * 18})`}
            />
          ))}
        </g>
        <g>
          <circle cx="0" cy="0" r="60" fill="none" stroke="none" />
          {[...Array(20)].map((_, i) => (
            <line
              key={`inner-${i}`}
              x1="0"
              y1="-56"
              x2="0"
              y2="-48"
              transform={`rotate(${i * 18})`}
            />
          ))}
        </g>
      </g>
    </svg>
  );
}

export function EnterpriseShell({ children }) {
  return (
    <div className="vt-shell">
      <div className="vt-wrap">{children}</div>
    </div>
  );
}

export function EnterpriseTopBar({ right }) {
  return (
    <header className="vt-topbar">
      <Link to="/" className="vt-brand" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <BrandMark />
        <span className="vt-brandName">Veritage</span>
      </Link>
      <div className="vt-topbarRight">{right}</div>
    </header>
  );
}

export function EnterpriseHero({ kicker, meta, title, subtitle }) {
  return (
    <section className="vt-hero">
      {(kicker || meta) && (
        <div className="vt-heroTop">
          {kicker && <span className="vt-chip">{kicker}</span>}
          {kicker && meta && <span className="vt-heroDivider" aria-hidden="true" />}
          {meta && <span className="vt-heroMeta">{meta}</span>}
        </div>
      )}
      {title && <h1 className="vt-title">{title}</h1>}
      {subtitle && <p className="vt-subtitle">{subtitle}</p>}
    </section>
  );
}

export function EnterpriseGrid({ children, columns = 2 }) {
  const className = columns === 1 ? 'vt-grid vt-grid--1' : 'vt-grid';
  return <section className={className}>{children}</section>;
}

export function EnterpriseCard({ children, className = '' }) {
  return <article className={['vt-card', className].filter(Boolean).join(' ')}>{children}</article>;
}

export function EnterpriseButton({ variant = 'primary', className = '', children, ...props }) {
  const v = variant === 'secondary' ? 'vt-btn vt-btn--secondary' : 'vt-btn vt-btn--primary';
  return (
    <button className={[v, className].filter(Boolean).join(' ')} {...props}>
      {children}
    </button>
  );
}

export function BackButton({ onClick, label = 'Back' }) {
  return (
    <button className="vt-back" type="button" onClick={onClick}>
      <ArrowBackRounded className="vt-btnIcon" />
      <span>{label}</span>
    </button>
  );
}

export function WarningBanner({ children, onClose }) {
  return (
    <div className="vt-banner" role="status" aria-live="polite">
      <WarningAmberRounded className="vt-btnIcon" />
      <span className="vt-bannerText">{children}</span>
      {onClose && (
        <button className="vt-bannerClose" type="button" onClick={onClose} aria-label="Dismiss">
          <CloseRounded className="vt-btnIcon" />
        </button>
      )}
    </div>
  );
}

